export default __webpack_public_path__ + "static/media/bars-progress-solid-full-teal.220e6a17.svg";